var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBestPrice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "11-best price"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 42a4 4 0 0 0-4-4H25.13l.87-6.88a.49.49 0 0 0 0-.12c0-5.54-3.92-7-6-7a1 1 0 0 0-1 .73l-4 13.89a7.67 7.67 0 0 1-3 3.17V41a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-.67L17.73 64a.8.8 0 0 0 .27 0h17a4 4 0 0 0 3-6.58 4 4 0 0 0 1-6 4 4 0 0 0 1-6A4 4 0 0 0 42 42ZM10 62H2V42h8Zm25 0H18.14L12 60.25V43.88c3-.69 4.81-4.26 4.89-4.43a1.34 1.34 0 0 0 .07-.18l3.77-13.18c1.17.26 3.25 1.23 3.27 4.85l-1 7.94a1 1 0 0 0 .24.78A1 1 0 0 0 24 40h14a2 2 0 0 1 0 4h-5a1 1 0 0 0 0 2h4a2 2 0 0 1 0 4h-5a1 1 0 0 0 0 2h4a2 2 0 0 1 0 4h-5a1 1 0 0 0 0 2h4a2 2 0 0 1 0 4ZM13 15h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2ZM54 50h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2Z",
    fill: "#ffa500",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 0a22 22 0 0 0-22 22 1 1 0 0 0 2 0 20 20 0 1 1 23.81 19.64 1 1 0 0 0 .19 2h.19A22 22 0 0 0 42 0Z",
    fill: "#ffa500",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 26a8 8 0 0 0-8-8h-2a2 2 0 0 1 0-4h7a3 3 0 0 0 0-6h-3V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3.26A8 8 0 0 0 41 24h2a2 2 0 0 1 0 4h-7a3 3 0 0 0 0 6h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3.26A8 8 0 0 0 51 26Zm-7.14 5.93a1 1 0 0 0-.86 1V36h-2v-3a1 1 0 0 0-1-1h-4a1 1 0 0 1 0-2h7a4 4 0 0 0 0-8h-2a6 6 0 0 1-.86-11.93 1 1 0 0 0 .86-1V6h2v3a1 1 0 0 0 1 1h4a1 1 0 0 1 0 2h-7a4 4 0 0 0 0 8h2a6 6 0 0 1 .86 11.93Z",
    fill: "#ffa500",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestPrice);
export default __webpack_public_path__ + "static/media/best-price.2ffeccb099eec68fb949a5ff36ea8dca.svg";
export { ForwardRef as ReactComponent };